import { Box, BoxProps } from '@chakra-ui/layout';

const ViewParent: React.FC<BoxProps> = ({ children, ...rest }) => {
  return (
    <Box
      id='viewParent'
      position='relative'
      sx={{
        canvas: {
          width: '100%',
          height: '100%',
          borderRadius: '5px'
        }
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default ViewParent;
